import { CSSObjectWithLabel } from "react-select";
import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const DropdownContainer = styled.div`
  padding-top: 2.5em;
  width: 450px;

  label {
    font-size: ${fonts.smallMedium};
  }

  > div {
    padding-top: 0.5em;
  }
`;

export const Divider = styled.hr`
  margin: 0 0 1em 0;
  background-color: ${colours.highlightGrey};
  height: 1px;
`;

export const dropdownStyles = {
  control: (provided: CSSObjectWithLabel): CSSObjectWithLabel => ({
    ...provided,
    minHeight: "3rem",
    height: "auto",
    borderRadius: "200px",
    borderColor: colours.elexonBlue,
    boxShadow: "none",
    outline: "none",
    "&:hover": {
      borderColor: colours.darkGrey,
    },
  }),
  menu: (provided: CSSObjectWithLabel): CSSObjectWithLabel => ({
    ...provided,
    marginTop: 0,
  }),
  menuList: (provided: CSSObjectWithLabel): CSSObjectWithLabel => ({
    ...provided,
    paddingTop: 0,
  }),
  valueContainer: (provided: CSSObjectWithLabel): CSSObjectWithLabel => ({
    ...provided,
    paddingLeft: "1rem",
    paddingRight: "0.25rem",
  }),
  indicatorsContainer: (provided: CSSObjectWithLabel): CSSObjectWithLabel => ({
    ...provided,
    paddingRight: "0.75rem",
  }),
  placeholder: (provided: CSSObjectWithLabel): CSSObjectWithLabel => ({
    ...provided,
    color: colours.mediumGrey,
  }),
};
